export default __webpack_public_path__ + "static/media/calendar.645fbd53.svg";